import { FontWeights, Toggle } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { DEFAULT_IMAGE_EXTENSION, DEFAULT_IMAGE_RESOLUTION_MAP, ImageDropdown } from "./ImageDropdown";
import { DocumentPartMetadata } from "../../api/models/document-part-metadata";

interface InheritableImageDropdownProps {
  documentPartMetadata: DocumentPartMetadata;
  inherit: boolean;
  imageExtension: string;
  imageResolution: number;
  required: boolean;
  onToggle: (inheritImageFormat: boolean, imageExtension: string, imageResolution: number, modified: boolean) => void;
  onExtensionChange: (option: string | number, modified: boolean) => void;
  onResolutionChange: (option: string | number, modified: boolean) => void;
  isFileExcelExisting?: boolean;
  isComponentInstance?: boolean;
}

const customToggleStyles = {
  label: {
    fontWeight: FontWeights.regular,
    display: "inline-block",
    marginRight: "5px",
  },
  container: {
    display: "inline-block",
  },
};

export const InheritableImageDropdown: React.FC<InheritableImageDropdownProps> = ({
  documentPartMetadata,
  inherit,
  imageExtension,
  imageResolution,
  required,
  onToggle,
  onExtensionChange,
  onResolutionChange,
  isFileExcelExisting,
  isComponentInstance,
}) => {
  const [inheritImageFormat, setInheritImageFormat] = useState<boolean>(inherit);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    if (inheritImageFormat) {
      // inherit, use document values
      onToggle(
        true,
        documentPartMetadata?.formatImage?.imageExtension,
        documentPartMetadata?.formatImage?.imageResolution,
        edit
      );
    } else {
      onToggle(
        false,
        imageExtension ?? DEFAULT_IMAGE_EXTENSION,
        imageResolution ?? DEFAULT_IMAGE_RESOLUTION_MAP.get(DEFAULT_IMAGE_EXTENSION),
        edit
      );
    }

    setEdit(false);
  }, [inheritImageFormat, documentPartMetadata, imageExtension, imageResolution, ImageDropdown]);

  const handleInheritToggle = (isChecked) => {
    setEdit(true);
    setInheritImageFormat(isChecked);
  };

  return (
    <>
      <div style={{ display: "inline-flex", verticalAlign: "top", float: "right" }}>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <Toggle
            styles={customToggleStyles}
            label={formatMessage("cof.createnewobject.inheritformat")}
            checked={inheritImageFormat}
            disabled={!isFileExcelExisting || isComponentInstance}
            onChange={(_event, inheritImageFormat?: boolean) => handleInheritToggle(inheritImageFormat)}
          />
        </div>
      </div>
      <ImageDropdown
        imageExtension={imageExtension}
        imageResolution={imageResolution}
        disabled={inheritImageFormat || !isFileExcelExisting || isComponentInstance}
        required={required}
        onExtensionChange={onExtensionChange}
        onResolutionChange={onResolutionChange}
      />
    </>
  );
};
